import { loadDismissablePrompts } from '@ms/yammer-data/dist/domains/dismissablePrompts/actions';
import type { DismissablePromptType } from '@ms/yammer-data/dist/state/types';
import { isEventsPage } from '@ms/yammer-web-support/dist/location';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

export type UseLoadDismissablePromptsByType = (promptTypes: DismissablePromptType[]) => void;
export const useLoadDismissablePromptsByType: UseLoadDismissablePromptsByType = (promptTypes) => {
  const dispatch = useDispatch();
  const isLiveEventPage = isEventsPage(window.location.pathname);

  useEffect(() => {
    if (isLiveEventPage) {
      return;
    }

    dispatch(loadDismissablePrompts({ promptTypes }));

    // oxlint-disable-next-line react/exhaustive-deps
  }, [dispatch, ...promptTypes, isLiveEventPage]);
};
